import { Type } from "@angular/core";
import { DatePickerType } from "../../../models/date.model";
import { DatePickerComponent } from "../components/date-picker.component";
import { DateRangePickerComponent } from "../components/date-rangepicker.component";

export const DATE_PICKER_TYPES: Record<DatePickerType, Type<unknown>> = {
  date:     DatePickerComponent,
  month:    DatePickerComponent,
  quarter:  DatePickerComponent,
  range:    DateRangePickerComponent,
  week:     DatePickerComponent,
  year:     DatePickerComponent,
};

export const ALLOWED_INPUTS_BY_DATE_TYPE: Record<DatePickerType, string[]> = {
  date:     [],
  month:    [],
  quarter:  [],
  range:    [],
  week:     [],
  year:     [],
};
